import { useMemo, useState } from 'react';

export interface CollapsedItems {
  [key: number]: boolean;
}

export function useCollapse() {
  const [items, setItems] = useState<CollapsedItems>({});

  const values: boolean[] = useMemo(() => Object.values(items), [items]);
  const allCollapsed: boolean = useMemo(() => {
    return values.every((value: boolean) => value);
  }, [values]);
  const allExpanded: boolean = useMemo(() => {
    return values.every((value: boolean) => !value);
  }, [values]);
  const partialCollapsed: boolean = useMemo(() => {
    return !allCollapsed && values.some((value: boolean) => value);
  }, [allCollapsed, values]);

  const resetItems = (...ids: number[]) => {
    const newItems: CollapsedItems = {};
    for (const id of ids) {
      newItems[id] = items[id] ?? false;
    }
    setItems(newItems);
  };

  const toggle = (id: number, collapse?: boolean) => {
    setItems({ ...items, [id]: collapse ?? !items[id] });
  };

  const toggleAll = () => {
    const newItems: CollapsedItems = { ...items };
    for (const key of Object.keys(newItems)) {
      if (allCollapsed) {
        newItems[+key] = false;
      } else if (allExpanded || partialCollapsed) {
        newItems[+key] = true;
      }
    }
    setItems(newItems);
  };

  return { items, allCollapsed, toggle, toggleAll, resetItems };
}
